import React, { useState, useEffect } from 'react';
import BaseModel from '../../BaseModal'
import { FlexWrapperCenter, LineView, GapView, FlexWrapper } from '../../styles/WrapperStyles';
import { InputText } from '../../styles/TextStyles';
import { BottomButton } from '../../styles/ButtonStyles';
import styled from 'styled-components';
import Loader from '../Loader';
import {getDate, getTime} from '../../utils';
import { ImageCirlceView } from '../../styles/ImageWrapper';
import urls from '../../api/urls.json';
import { authorizedHttpGet } from '../../api/httpCalls';
import {getTTFB} from "web-vitals";

const ParentDiv = styled.div`
  width: 645px;
  height: 339px;
  border-radius: 20px;
`;

const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
`;

const InputStyle = styled(InputText)`
  width: 100px;
  height: 50px;
  border-radius: 10px;
`;

const GoButton = styled(BottomButton)`
  width: 50px;
  height: 50px;
  border-radius: 10px;
`;

const BottomButtonBelow = styled(BottomButton)`
  margin-top: 20px;
  margin-bottom: 20px;
`;

const InvitesModal = (props) => {
    const [list, setList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [info, setInfo] = useState(null);
    const [inputText, setInputText] = useState('');
    const [otherUserRef, setOtherUserRef] = useState(props.other_user_ref);
    const [showProgress, setShowProgress] = useState(false);

    useEffect(() => {
        if (otherUserRef !== null) {
            getUser(1);
        }
    }, [otherUserRef]);

    const getUser = async (page = 1) => {
        setShowProgress(true);
        let response = await authorizedHttpGet(urls.GET_CONNECTION_MESSAGES, { page: page, current_user_ref: props.current_user_ref, other_user_ref: otherUserRef });
        if (response.status) {
            if (response.data.request !== undefined && response.data.request !== null) {
                setInfo(response.data.request);
                setList(response.data.messages.messages_list);
                setCurrentPage(response.data.messages.page);
                setTotalPage(response.data.messages.total_pages);
            } else if (response.data.messages !== undefined && response.data.messages !== null && page !== 1) {
                setList([...list, ...response.data.messages.messages_list]);
                setCurrentPage(response.data.messages.page);
                setTotalPage(response.data.messages.total_pages);
            }
        }
        setShowProgress(false);
    };

    return (
        <BaseModel closeModal={() => props.closeModal()}>
            <ParentDiv>
                <FlexWrapperCenter>
                    <InputStyle
                        value={inputText}
                        onChange={(e) => {
                            setInputText(e.target.value);
                        }}
                    />
                    <GapView width="20px" />
                    <GoButton
                        onClick={() => {
                            setOtherUserRef(inputText);
                            setList([]);
                            setInfo(null);
                            setCurrentPage(1);
                            setTotalPage(1);
                            getUser(1);
                        }}
                    >
                        Go
                    </GoButton>
                </FlexWrapperCenter>
                <GapView height="20px" />
                {info !== null ? (
                    <FlexWrapper>
                        <GapView width="20px" />
                        <div>
                            <GapView height="20px" />
                            <ImageCirlceView src={info.avatar} />
                        </div>
                        <GapView width="20px" />
                        <div>
                            <TextView>
                                {info.name}
                                <br />
                                {info.ref}
                                <br />
                                Sent: {info.messages_info.sent}
                                <br />
                                Received: {info.messages_info.received}
                                <br />
                                Type: {info.connection_type}
                            </TextView>
                        </div>
                        <GapView width="20px" />
                        <div>
                            <TextView>
                                Invited: {getDate(info.invited_date)}
                                <br />
                                Connected: {getDate(info.connected_date)}
                                <br />
                                Deleted: {info.deleted ? 'true' : 'false'}
                                <br />
                                Unmatched: {getDate(info.unmatched_time)}
                                <br />
                                Blocked: {getDate(info.blocked_date)}
                                <br />
                                Blocked self: {getDate(info.blocked_self_date)}
                                <br />
                            </TextView>
                        </div>
                    </FlexWrapper>
                ) : null}
                {list.map((item, pos) => {
                    return (
                        <div key={pos}>
                            <GapView width="20px" />
                            <FlexWrapper>
                                <GapView width="20px" />
                                <TextView>{item.sender_name}</TextView>
                                <GapView width="20px" />
                                <div>
                                    <TextView>{item.content}</TextView>
                                    <TextView>{getDate(item.created_at)}</TextView>
                                    <TextView>{getTime(item.created_at)}</TextView>
                                </div>
                            </FlexWrapper>
                            <LineView />
                        </div>
                    );
                })}
                {currentPage < totalPage && !showProgress ? (
                    <BottomButtonBelow onClick={() => getUser(currentPage + 1)}>Load More</BottomButtonBelow>
                ) : null}
                {showProgress ? <Loader /> : null}
            </ParentDiv>
        </BaseModel>
    );
};

export default InvitesModal;
